module.exports = __webpack_public_path__ + "static/media/h5_yoga_pic4.a4dc92df.png";